module.exports = __webpack_public_path__ + "static/media/Instagram.180e804c.png";